import { Select, MenuItem } from "@mui/material";
import { GridFilterInputValueProps } from "@mui/x-data-grid";
import { SelectChangeEvent } from "@mui/material/Select";


export function FilterTypeInput(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const types = ["employee", "contractor"];
  const handleChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value || ""}
      onChange={handleChange}
      displayEmpty
      fullWidth
    >
      <MenuItem value="">All</MenuItem>
      {types.map((type) => (
        <MenuItem key={type} value={type}>
          {type}
        </MenuItem>
      ))}
    </Select>
  );
}